export const basePath = '/hato-heart'

export enum HATO_HEART_PATHS {
  HOME = '',
  REDIRECT_HH_TO_LIFF = 'home',
  BURN_POINTS = 'burn-points',
  COUPONS = 'coupons',
  FEEDBACK = 'feedback',
  TRANSACTIONS = 'transactions',
}

export const getPathHatoHeart = (path: HATO_HEART_PATHS) => (path ? `${basePath}/${path}` : basePath)
